"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericConfigSection = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const css_1 = require("@emotion/css");
const ui_1 = require("@grafana/ui");
const GenericConfigSection = ({ children, title, description, isCollapsible = false, isInitiallyOpen = true, kind = 'section', className, }) => {
    const { colors, typography, spacing } = (0, ui_1.useTheme2)();
    const [isOpen, setIsOpen] = (0, react_1.useState)(isCollapsible ? isInitiallyOpen : true);
    const iconName = isOpen ? 'angle-up' : 'angle-down';
    const isSubSection = kind === 'sub-section';
    const collapsibleButtonAriaLabel = `${isOpen ? 'Collapse' : 'Expand'} section ${title}`;
    const styles = {
        header: (0, css_1.css)({
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        }),
        title: (0, css_1.css)({
            margin: 0,
        }),
        subtitle: (0, css_1.css)({
            margin: 0,
            fontWeight: typography.fontWeightRegular,
        }),
        descriptionText: (0, css_1.css)(Object.assign(Object.assign({ marginTop: spacing(isSubSection ? 0.25 : 0.5), marginBottom: 0 }, typography.bodySmall), { color: colors.text.secondary })),
        content: (0, css_1.css)({
            marginTop: spacing(2),
        }),
    };
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: styles.header },
            kind === 'section' ? react_1.default.createElement("h3", { className: styles.title }, title) : react_1.default.createElement("h6", { className: styles.subtitle }, title),
            isCollapsible && (react_1.default.createElement(ui_1.IconButton, { name: iconName, onClick: () => setIsOpen(!isOpen), type: "button", size: "xl", "aria-label": collapsibleButtonAriaLabel }))),
        description && react_1.default.createElement("p", { className: styles.descriptionText }, description),
        isOpen && react_1.default.createElement("div", { className: styles.content }, children)));
};
exports.GenericConfigSection = GenericConfigSection;
//# sourceMappingURL=GenericConfigSection.js.map